
const DEFAULT_LANGUAGE = "tr";

const ROUTES = {
  INDEX: "/",
  ETECH: "/megane_e_tech",
  AUSTRAL: "/austral_hybrid",
  RENAULT_DUSTER: "/renault_duster",
  RENAULT_KANGOO_MULTIX: "/renault_kangoo_multix",
  RENAULT_MASTER: "/renault_master",
  CLIO6: "/clio6",
  NOT_FOUND: "/404",
  LINK_NOT_FOUND: "/",
};

const IMAGES = {
  LOGO_MAIN: "renault_logo_white.png",
  LOGO_MAIS: "MAIS_YETKILI_SATICI_LOGOSU_ONAYLI.jpg",
  ETECH_BACKGROUND: "2021_-_New_Renault_Megane_E-TECH_Electric_-_Urban (1) (1).jpeg",
  AUSTRAL_BACKGROUND: "austral_background_image.jpg",
  RENAULT_DUSTER_BACKGROUND: "Yeni_Renault_Duster4.jpg",
  FAVICON_AUSTRAL: "favicon.ico",
  TITLE: "RENAULT KÜTÜPHANE",
  VEHICLE_PAGE_IMG: "renault_vehicle_page_image.jpg",
  SERVICE_PAGE_IMG: "renault_service_page_image.jpg",
  COMMENT_PAGE_IMG: "renault_comment_page_image.jpg",
  ERROR_PAGE_IMG: "error_renault.jpg",
  RENAULT_KANGOO_MULTIX_BACKGROUND: "renaultKangoo.jpg",
  RENAULT_MASTER_BACKGROUND: "renaultMaster.jpg",
  CLIO6_BACKGROUND: "clio6.jpg",
};

const SURVEY_IDS = {
  RENAULT_DUSTER: 17,
  MEGANE_E_TECH: 14,
  AUSTRAL: 15,

  RENAULT_MASTER_STAGING: 23, //stagin idleri
  RENAULT_KANGOO_MULTIX_STAGING: 24, //stagin idleri

  RENAULT_MASTER: 22,
  RENAULT_KANGOO_MULTIX: 23,
  CLIO6: 27,
};

export { IMAGES, DEFAULT_LANGUAGE, ROUTES, SURVEY_IDS };
